// extracted by mini-css-extract-plugin
export var cost = "cost-module--cost--b937f";
export var cost__col = "cost-module--cost__col--3efcc";
export var cost__installment = "cost-module--cost__installment--ae1bb";
export var cost__installment_btn = "cost-module--cost__installment_btn--48b6b";
export var cost__installment_text = "cost-module--cost__installment_text--bcd0e";
export var cost__item = "cost-module--cost__item--2b65e";
export var cost__item_1 = "cost-module--cost__item_1--18fe3";
export var cost__item_2 = "cost-module--cost__item_2--e0d07";
export var cost__item_3 = "cost-module--cost__item_3--ff383";
export var cost__item_body = "cost-module--cost__item_body--987fd";
export var cost__item_btn = "cost-module--cost__item_btn--c2086";
export var cost__item_header = "cost-module--cost__item_header--40c6a";
export var cost__item_list = "cost-module--cost__item_list--bdf51";
export var cost__item_title = "cost-module--cost__item_title--1ab6a";
export var cost__row = "cost-module--cost__row--20443";
export var month = "cost-module--month--43514";
export var newcost = "cost-module--newcost--ad755";